import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';

interface GlobalEvent {
  key: any;
  data?: any;
}

@Injectable()
export class EventsService {
  private _eventBus: Subject<GlobalEvent>;

  constructor() {
    this._eventBus = new Subject<GlobalEvent>();
  }

  trigger(key: string, data?: any) {
    this._eventBus.next({key, data});
  }

  on<T>(key: string): Observable<T> {
    return this._eventBus.asObservable()
      .filter(event => event.key === key)
      .map(event => <T>event.data);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/events.service.ts